var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sticker)?_c('img',{staticClass:"sticker",attrs:{"src":_vm.sticker}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }